import { COMPLETENESS_HIGH_THRESHOLD } from '../../../constants/completeness';

interface MiniCompletenessDonutProps {
  value: number;
}

export function MiniCompletenessDonut({ value }: MiniCompletenessDonutProps) {
  const clamped = Math.max(0, Math.min(100, value));
  const isHigh = clamped > COMPLETENESS_HIGH_THRESHOLD;

  return (
    <span
      role="img"
      aria-label={`${clamped}% complete`}
      data-high={isHigh ? 'true' : 'false'}
      className="demo-completeness-donut completeness-donut shrink-0"
      style={{ '--progress': `${clamped}%` } as React.CSSProperties}
    />
  );
}
